import { render, staticRenderFns } from "./FrequencyCaps.vue?vue&type=template&id=50ea77fa&"
import script from "./FrequencyCaps.vue?vue&type=script&lang=ts&"
export * from "./FrequencyCaps.vue?vue&type=script&lang=ts&"
import style0 from "./FrequencyCaps.vue?vue&type=style&index=0&id=50ea77fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports